function setVideoRatio( portrait = false ) {
    let video = document.querySelectorAll('.responsive-video');

    let fullHdRatio = 1920 / 1080;

    if( portrait ) {
        fullHdRatio = 1080 / 1920;
    }

    let windowHeight = window.innerHeight;
    let windowWidth = window.innerWidth;

    let videoHeight = windowWidth / fullHdRatio;
    if( videoHeight < windowHeight ) {
        videoHeight = windowHeight;
    }
    let videoWidth = videoHeight * fullHdRatio;

    video.forEach( el => {
        el.style.width = videoWidth+'px';
        el.style.height = videoHeight+'px';
    })
}

export function mobileVideoRatio() {
    if( document.querySelectorAll('.responsive-video') ) {
        setVideoRatio( true );
        window.addEventListener('resize', setVideoRatio);
    }
}

export default function() {
    if( document.querySelectorAll('.responsive-video') ) {
        setVideoRatio();
        window.addEventListener('resize', setVideoRatio);
    }
}